export function ProductSection() {
  const products = [
    {
      title: 'Software Development & Digital Solutions',
      description: 'Custom enterprise software, web and mobile applications, and end-to-end digital strategy solutions tailored to your business needs',
      image: 'https://static.readdy.ai/image/8ff5f191f084c4fb11b85d16f9e2729c/87caaedd36639523ce57d8ab00c7f66d.jpeg',
      features: ['Custom Software', 'Web & Mobile Apps', 'Digital Strategy', 'Cloud Solutions']
    },
    {
      title: 'AI Automated Systems',
      description: 'Advanced AI-powered automation systems designed for large-scale businesses to optimize operations and drive efficiency',
      image: 'https://public.readdy.ai/ai/img_res/298684c7a0d08c1aa6f3b6fc1fd31fbf.jpg',
      features: ['Process Automation', 'AI Integration', 'Data Analytics', 'Smart Systems']
    },
    {
      title: 'Marketing & Media Solutions',
      description: 'Comprehensive digital marketing, branding strategies, media production, photography, videography, and media management services',
      image: 'https://static.readdy.ai/image/8ff5f191f084c4fb11b85d16f9e2729c/3310434f8b5ad9926db508e6e099a009.jpeg',
      features: ['Digital Marketing', 'Media Production', 'Photography', 'Videography']
    },
    {
      title: 'Creative Design & Branding',
      description: 'Complete brand identity development, motion graphics, creative design services, and visual storytelling for impactful brand presence',
      image: 'https://readdy.ai/api/search-image?query=Creative%20design%20studio%20workspace%20with%20brand%20identity%20materials%20and%20graphic%20design%20tools%2C%20modern%20minimalist%20setup%20with%20purple%20and%20violet%20color%20schemes%2C%20professional%20branding%20mockups%20and%20design%20elements%2C%20sleek%20contemporary%20creative%20environment&width=800&height=600&seq=tehkzone004&orientation=landscape',
      features: ['Brand Identity', 'Motion Graphics', 'Visual Design', 'Creative Strategy']
    },
    {
      title: 'High-Tech Gadget Importation',
      description: 'Premium high-tech equipment importation and distribution for organizations, governments, and businesses requiring advanced technology',
      image: 'https://readdy.ai/api/search-image?query=High-tech%20gadgets%20and%20modern%20technology%20devices%20display%2C%20premium%20electronic%20equipment%20and%20advanced%20technological%20products%2C%20sleek%20minimalist%20presentation%20with%20purple%20and%20violet%20lighting%20accents%2C%20professional%20technology%20showcase%20with%20cutting-edge%20devices&width=800&height=600&seq=tehkzone005&orientation=landscape',
      features: ['Tech Equipment', 'Enterprise Hardware', 'Distribution', 'Tech Support']
    }
  ];

  return (
    <section id="products" className="py-24">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-extralight text-white mb-6 tracking-[0.1em]">
            Our Services
          </h2>
          <p className="text-gray-400 text-lg font-light max-w-3xl mx-auto">
            Integrated solutions combining creativity with functionality under one roof
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {products.map((product, index) => (
            <div 
              key={index}
              className="group relative bg-black/30 backdrop-blur-sm border border-white/10 rounded-2xl overflow-hidden transition-all duration-500 hover:border-purple-400/50 hover:scale-[1.02] cursor-pointer"
            >
              {/* Image */}
              <div className="relative h-80 overflow-hidden">
                <img 
                  src={product.image}
                  alt={product.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
              </div>
              
              {/* Content */}
              <div className="p-8">
                <h3 className="text-2xl font-light text-white mb-4 tracking-wide">
                  {product.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed font-light mb-6">
                  {product.description}
                </p>
                
                {/* Features */}
                <div className="flex flex-wrap gap-2">
                  {product.features.map((feature, idx) => (
                    <span 
                      key={idx}
                      className="px-4 py-2 bg-violet-500/10 border border-violet-400/30 rounded-lg text-violet-300 text-xs font-light"
                    >
                      {feature}
                    </span>
                  ))}
                </div>
              </div>
              
              {/* Hover Effect */}
              <div className="absolute bottom-0 left-0 w-0 h-1 bg-gradient-to-r from-violet-400 to-purple-400 group-hover:w-full transition-all duration-500"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
